/* Backstage "Attach originals": the PDFs of documents indexed before Clara kept them.

   The admin drops the whole folder at once; it goes up in small batches so no single
   request is larger than the ingress allows, and Clara matches each file to a document by
   the sha256 of its bytes. */

export const BATCH_FILES = 10
export const BATCH_BYTES = 48 * 1024 * 1024

export function batchFiles(files, maxFiles = BATCH_FILES, maxBytes = BATCH_BYTES) {
	const batches = []
	let current = []
	let size = 0
	for (const file of files) {
		if (current.length && (current.length >= maxFiles || size + file.size > maxBytes)) {
			batches.push(current)
			current = []
			size = 0
		}
		current.push(file)
		size += file.size
	}
	if (current.length) batches.push(current)
	return batches
}

export const LARGE_SET = 50

export function attachSummary({ matched = [], unmatched = [], failed = [] }, fileCount = 0) {
	const attached = matched.filter(m => !m.already_stored).length
	const already = matched.length - attached
	const parts = [`Attached ${attached} original${attached === 1 ? "" : "s"}.`]
	if (already) parts.push(`${already} ${already === 1 ? "was" : "were"} already stored.`)
	if (unmatched.length) {
		// A match needs the exact file that was uploaded; a re-exported copy of the same policy is a different file.
		parts.push(`${unmatched.length} file${unmatched.length === 1 ? "" : "s"} matched no uploaded document: ${unmatched.join(", ")}.`)
	}
	if (failed.length) parts.push(`${failed.length} failed: ${failed.map(f => `${f.filename} (${f.error})`).join(", ")}.`)
	if (fileCount > LARGE_SET) {
		parts.push("For large sets, the server command python -m clara.backfill_originals is safer: it dry runs first and writes a report (see docs/originals-backfill.md in the clara repo).")
	}
	return parts.join(" ")
}

// None are "missing" when Clara keeps no originals at all: there is nothing to attach them to.
export function missingOriginals(documents, originalsStored) {
	return originalsStored ? documents.filter(d => !d.has_original).length : 0
}
